import { type ChangeEvent, type FormEvent, memo, useRef, useState } from "react";
import { Button, ButtonTypes, Input, Modal } from "@clintonelec/react-storybook";
import "Components/ConfigLayout/Network/SecuritySettings/CertificateSelectModal/CertificateSelectModal.less";
import type { SecurityCertificate } from "Interfaces";

type CertificateSelectModalProps = {
	ieeeEnabled?: boolean;
	certificate: SecurityCertificate;
	handleCertUpdate?: (cert: SecurityCertificate) => void;
};

function CertificateSelectModal(props: CertificateSelectModalProps) {
	const { ieeeEnabled, certificate, handleCertUpdate } = props;
	const [ visible, setVisible ] = useState(false);
	const [ selectedFile, setSelectedFile ] = useState<File | null>(null);
	const fileSelectRef = useRef<HTMLInputElement>(null);

	const handleVisibilityChange = (newVisibility: boolean) => {
		setSelectedFile(null);
		setVisible(newVisibility);
	};

	const handleSelectedFileChange = (event: ChangeEvent<HTMLInputElement>) => {
		const selectedFiles = event.target?.files;

		if (!selectedFiles || selectedFiles.length === 0) {
			return;
		}

		setSelectedFile(selectedFiles[0]);
	};

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		setVisible(false);
		handleCertUpdate?.({
			...certificate,
			name: selectedFile?.name ?? ""
		});
	};

	const modalContent = (
		<form className="certificate-select-modal-content" onSubmit={ handleSubmit } noValidate>
			<div className="file-selector">
				<input
					hidden
					onChange={ handleSelectedFileChange }
					ref={ fileSelectRef }
					type="file"
				/>
				<Input
					className="file-label"
					disabled
					value={ selectedFile?.name }
				/>
				<Button
					onClick={ () => fileSelectRef.current?.click() }
					htmlType="button"
					type={ ButtonTypes.TERTIARY }
				>
					Choose File
				</Button>
			</div>
			<div className="submit-button">
				<Button
					disabled={ !selectedFile }
					fill
					type={ ButtonTypes.TERTIARY }
				>
					Upload
				</Button>
			</div>
		</form>
	);

	return (
		<Modal
			title="Open File"
			modalContent={ modalContent }
			onVisibilityChange={ handleVisibilityChange }
			visible={ visible }
			width={ 400 }
		>
			<Button
				className="cert-button"
				disabled={ !ieeeEnabled }
				htmlType="button"
				type={ ButtonTypes.TERTIARY }
			>
				Find
			</Button>
		</Modal>
	);
}

export default memo(CertificateSelectModal);
